import { Link } from 'react-router-dom';
import { genreOptions, movies } from '@/mocks/movies';

export default function CategorySidebar() {
  const ranking = [...movies].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <aside className="space-y-5">
      <div className="rounded-xl border border-background-200 bg-background-50 p-4">
        <h3 className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-apps-2-line text-accent-500"></i> 内容分类
        </h3>
        <div className="space-y-1">
          <Link
            to="/category/movie"
            className="flex items-center justify-between rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
          >
            <span className="flex items-center gap-2"><i className="ri-film-line"></i> 全部电影</span>
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
          </Link>
          <Link
            to="/category/tv"
            className="flex items-center justify-between rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
          >
            <span className="flex items-center gap-2"><i className="ri-tv-2-line"></i> 全部电视剧</span>
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
          </Link>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5 border-t border-background-200 pt-3">
          {genreOptions.map((genre) => (
            <Link
              key={genre}
              to={`/search?q=${encodeURIComponent(genre)}`}
              className="rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600 transition-colors hover:bg-accent-500 hover:text-background-50"
            >
              {genre}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-50 p-4">
        <h3 className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-trophy-line text-secondary-500"></i> 热门榜单
        </h3>
        <ol className="space-y-1">
          {ranking.map((movie, index) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    index < 3 ? 'bg-accent-500 text-background-50 dark:text-foreground-950' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-medium text-foreground-800 group-hover:text-primary-600">{movie.title}</span>
                  <span className="text-xs text-foreground-400">{movie.year} · {movie.region}</span>
                </span>
                <span className="shrink-0 text-xs font-bold text-secondary-600">{movie.rating.toFixed(1)}</span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}